import React, { useState, useEffect, useContext, Component } from 'react';
 import Header from '../../components/Header';
import Footer from '../../components/Footer';

const TestingHospitalView = () => {

    return (
        <>
            <Header />

            <main className="page">
 
  {/* HERO */}
  <section className="page-hero py-4 py-lg-5">
    <div className="container">

      {/* Breadcrumb */}
      <div className="small text-muted mb-3">
        Home <span className="mx-1">›</span> Hospitals <span className="mx-1">›</span>
        <span className="fw-semibold text-dark">Dental Park Hospital</span>
      </div>

      <div className="row g-4 align-items-start">

        {/* LEFT: Hospital identity */}
        <div className="col-lg-4">
          <div className="glass p-4">

            <div className="d-flex align-items-start justify-content-between gap-3">
              <div className="d-flex align-items-center gap-3">
                <div
                  className="rounded-4 d-flex align-items-center justify-content-center"
                  style={{width:56,height:56, background:"rgba(13,110,253,.12)", color:"var(--navy)", fontWeight:900}}
                >
                  MC
                </div>

                <div>
                  <div className="fw-bold fs-4" style={{color:"var(--navy)"}}>
                  Manipal Clinic
                  </div>
                  <div className="text-muted small">
                    Dental • Multi-speciality • ISO Certified
                  </div>
                </div>
              </div>

              <span className="badge bg-success-subtle text-success rounded-pill px-3 py-2">
                Open Now
              </span>
            </div>

            {/* Trust row */}
            <div className="d-flex flex-wrap gap-2 mt-3">
              <span className="pill">
                <span className="fw-bold"> <img width={80} src="https://www.pngall.com/wp-content/uploads/13/Google-Logo-PNG-Pic.png"/> </span>
                <span className="fw-bold">4.9</span>
                <span style={{color:"#F4B400"}}>★★★★★</span>
                <span className="text-muted">(250+)</span>
              </span>
              <span className="pill">✅ Verified Listing</span>
              <span className="pill">⏱ Avg wait 10–15 min</span>
            </div>

            <hr className="my-4" />

            {/* Key info */}
            <div className="d-flex gap-3 mb-3">
              <div className="rounded-circle d-flex align-items-center justify-content-center"
                   style={{width:38,height:38, background:"rgba(255,193,7,.18)"}}>
                📍
              </div>
              <div>
                <div className="fw-semibold">Guru Harkishan Nagar, New Delhi</div>
                <div className="text-muted small">M-123, Near Allahabad Bank, Paschim Vihar</div>
                <a href="#" className="text-decoration-none fw-semibold">Get Directions →</a>
              </div>
            </div>

            <div className="d-flex gap-3 mb-3">
              <div className="rounded-circle d-flex align-items-center justify-content-center"
                   style={{width:38,height:38, background:"rgba(13,110,253,.12)"}}>
                ⏰
              </div>
              <div>
                <div className="fw-semibold">10:00 AM – 08:00 PM</div>
                <div className="text-muted small">Closed on Monday</div>
              </div>
            </div>

            {/* Highlights */}
            <div className="d-flex flex-wrap gap-2 mt-3">
              <span className="pill">🦷 Implants</span>
              <span className="pill">✨ Cosmetic</span>
              <span className="pill">🧒 Kids Dentistry</span>
              <span className="pill">🪥 Cleaning</span>
              <span className="pill">🦷 RCT</span>
            </div>

            {/* CTAs */}
            <div className="d-flex gap-2 mt-4 flex-wrap">
              <a href="tel:9667353232" className="btn btn-outline-primary cta-btn flex-grow-1">
                📞 Call
              </a>
              <button className="btn btn-primary cta-btn flex-grow-1">
                📅 Book Appointment
              </button>
            </div>

          </div>
        </div>

        {/* CENTER: Gallery + Map */}
        <div className="col-lg-5">
          <div className="thumb mb-3">
            <img className="img-fluid" alt="hospital" src="https://www.globalcarehealth.com/img/hospitalsimg/Manipal-Hospital-Old-Airport-Road-Bengaluru-India-gchh51.webp" />
          </div>

          <div className="row g-3">
            <div className="col-4">
              <div className="thumb">
                <img className="img-fluid" alt="gallery" src="https://etimg.etb2bimg.com/photo/93891569.cms"  style={{aspectRatio:'1/1'}}/>
              </div>
            </div>
            <div className="col-4">
              <div className="thumb">
                <img className="img-fluid" alt="gallery" src="https://www.manipalhospitals.com/uploads/photo_gallery/Executive_Special_Room.png"  style={{aspectRatio:'1/1'}}/>
              </div>
            </div>
            <div className="col-4">
              <div className="thumb d-flex align-items-center justify-content-center position-relative" style={{minHeight:96}}> 
                  <img className="img-fluid w-100 h-100 position-absolute" alt="gallery" src="https://www.manipalhospitals.com/oldairportroad/uploads/specialities/best-radiology-hospital.png"  />
                 <button className="btn btn-light border rounded-pill z-1">View All Photos →</button>
              </div>
            </div>
          </div>

          <div className="thumb mt-3">
<iframe
  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d56050.40815165902!2d76.99321746826173!3d28.595261250489052!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390d1b3ae0cf4f6f%3A0xec55552f03c1526d!2sManipal%20Hospital%20Delhi!5e0!3m2!1sen!2sin!4v1765627945863!5m2!1sen!2sin"
  width={600}
  height={500}
  style={{ border: 0 }}
  allowFullScreen=""
  loading="lazy"
  referrerPolicy="no-referrer-when-downgrade"
/>

           </div>
        </div>

        {/* RIGHT: Sticky booking */}
        <div className="col-lg-3">
          <div className="sticky-side">
            <div className="glass p-4">

              <div className="d-flex align-items-center justify-content-between mb-2">
                <div className="fw-bold" style={{color:"var(--navy)"}}>Book a Slot</div>
                <span className="badge bg-warning-subtle text-warning rounded-pill">Upto 25% OFF</span>
              </div>

              <div className="text-muted small mb-3">
                Get priority confirmation within minutes.
              </div>

              <div className="row g-2">
                <div className="col-12">
                  <input className="form-control" placeholder="Full Name" />
                </div>
                <div className="col-12">
                  <input className="form-control" placeholder="Phone Number" />
                </div>
                <div className="col-12">
                  <select className="form-select">
                    <option>Choose Service</option>
                    <option>Dental Implants</option>
                    <option>RCT</option>
                    <option>Aligners</option>
                    <option>Cleaning</option>
                  </select>
                </div>
                <div className="col-12">
                  <select className="form-select">
                    <option>Preferred Time</option>
                    <option>Morning</option>
                    <option>Afternoon</option>
                    <option>Evening</option>
                  </select>
                </div>
                <div className="col-12">
                  <button className="btn btn-primary w-100 cta-btn">
                    Confirm Booking →
                  </button>
                </div>
              </div>

              <div className="d-flex gap-2 mt-3 flex-wrap">
                <span className="pill">✅ Free Consult*</span>
                <span className="pill">🛡 Hygiene</span>
                <span className="pill">⚡ Fast Slots</span>
              </div>

              <div className="small text-muted mt-3">
                By booking, you agree to terms & privacy policy.
              </div>

            </div>
          </div>
        </div>

      </div>

      {/* Tabs */}
      <div className="mt-4">
        <ul className="nav nav-pills gap-2 navtabs flex-wrap">
          <li className="nav-item"><a className="nav-link active" href="#overview">Overview</a></li>
          <li className="nav-item"><a className="nav-link" href="#doctors">Doctors</a></li>
          <li className="nav-item"><a className="nav-link" href="#services">Services</a></li>
          <li className="nav-item"><a className="nav-link" href="#reviews">Reviews</a></li>
          <li className="nav-item"><a className="nav-link" href="#faq">FAQ</a></li>
        </ul>
      </div>

    </div>
  </section>

  {/* OVERVIEW */}
  <section id="overview" className="py-5">
    <div className="container">
      <div className="row g-4">
        <div className="col-lg-8">
          <div className="glass p-4">
            <h5 className="fw-bold mb-2" style={{color:"var(--navy)"}}>About this Hospital</h5>
            <p className="text-muted mb-0">
              Dental Park Hospital offers advanced dental care including implants, aligners, cosmetic dentistry,
              RCT, kids dentistry and preventive care. We follow strict sterilization and hygiene standards.
            </p>
          </div>
        </div>

        <div className="col-lg-4">
          <div className="glass p-4">
            <h6 className="fw-bold mb-3" style={{color:"var(--navy)"}}>Highlights</h6>
            <div className="d-flex flex-column gap-2">
              <div className="pill">✅ ISO Certified</div>
              <div className="pill">✅ Cashless/Insurance*</div>
              <div className="pill">✅ Wheelchair Accessible</div>
              <div className="pill">✅ Digital X-Ray</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  {/* DOCTORS (6 cards) */}
  <section id="doctors" className="py-5 bg-light">
    <div className="container">
      <div className="d-flex align-items-end justify-content-between flex-wrap gap-2 mb-3">
        <div>
          <h5 className="fw-bold mb-1" style={{color:"var(--navy)"}}>Doctors at this Hospital</h5>
          <div className="text-muted">Choose a specialist and book instantly</div>
        </div>
        <button className="btn btn-outline-primary rounded-pill">View All Doctors</button>
      </div>

      <div className="row g-4">
        {[1,2,3,4,5,6].map((i)=>(
          <div className="col-lg-4 col-md-6" key={i}>
            <div className="doc-card p-4 h-100">
              <div className="d-flex gap-3">
                <img className="rounded-4" src="https://via.placeholder.com/72" alt="doc" />
                <div className="flex-grow-1">
                  <div className="fw-bold">Dr. Doctor Name {i}</div>
                  <div className="text-muted small">Implants • Cosmetic • RCT</div>
                  <div className="d-flex gap-2 flex-wrap mt-2">
                    <span className="chip">★ 4.8</span>
                    <span className="chip">10+ yrs</span>
                    <span className="chip">Today Slots</span>
                  </div>
                </div>
              </div>

              <div className="d-flex gap-2 mt-4">
                <button className="btn btn-outline-primary w-50 rounded-pill">Profile</button>
                <button className="btn btn-primary w-50 rounded-pill">Book</button>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  </section>

  {/* SERVICES */}
  <section id="services" className="py-5">
    <div className="container">
      <h5 className="fw-bold mb-3" style={{color:"var(--navy)"}}>Treatments & Services</h5>
      <div className="row g-4">
        {["Dental Implants","Aligners","Root Canal (RCT)","Teeth Whitening","Kids Dentistry","Smile Makeover"].map((s,idx)=>(
          <div className="col-lg-4 col-md-6" key={idx}>
            <div className="glass p-4 h-100">
              <div className="fw-bold mb-1">{s}</div>
              <div className="text-muted small mb-3">Safe, hygienic, specialist-led care.</div>
              <button className="btn btn-outline-primary rounded-pill">Know More →</button>
            </div>
          </div>
        ))}
      </div>
    </div>
  </section>

  {/* REVIEWS */}
  <section id="reviews" className="py-5 bg-light">
    <div className="container">
      <div className="glass p-4">
        <div className="d-flex align-items-center justify-content-between flex-wrap gap-2">
          <div>
            <h5 className="fw-bold mb-1" style={{color:"var(--navy)"}}>Patient Reviews</h5>
            <div className="text-muted">Latest Google verified reviews</div>
          </div>
          <span className="pill">Google 4.9 ★★★★★ (250+)</span>
        </div>

        <div className="row g-3 mt-2">
          {[1,2,3].map((r)=>(
            <div className="col-lg-4" key={r}>
              <div className="p-3 border rounded-4 bg-white h-100">
                <div className="fw-semibold">Patient Name</div>
                <div className="small text-muted mb-2">2 weeks ago</div>
                <div className="small mb-2" style={{color:"#F4B400"}}>★★★★★</div>
                <div className="text-muted">
                  Excellent service and very professional staff. Highly recommended!
                </div>
              </div>
            </div>
          ))}
        </div>

      </div>
    </div>
  </section>

  {/* FAQ */}
  <section id="faq" className="py-5">
    <div className="container">
      <h5 className="fw-bold mb-3" style={{color:"var(--navy)"}}>Frequently Asked Questions</h5>

      <div className="accordion" id="faqAcc">
        {[
          ["What are the hospital timings?","We are open 10:00 AM to 08:00 PM. Closed on Monday."],
          ["Do you offer same-day appointments?","Yes, subject to slot availability. Use the booking form to confirm."],
          ["Do you accept insurance?","Insurance/cashless availability depends on your provider and plan."],
        ].map((q,idx)=>(
          <div className="accordion-item" key={idx}>
            <h2 className="accordion-header">
              <button
                className={`accordion-button ${idx!==0 ? "collapsed":""}`}
                type="button"
                data-bs-toggle="collapse"
                data-bs-target={`#faq${idx}`}
              >
                {q[0]}
              </button>
            </h2>
            <div id={`faq${idx}`} className={`accordion-collapse collapse ${idx===0 ? "show":""}`} data-bs-parent="#faqAcc">
              <div className="accordion-body text-muted">{q[1]}</div>
            </div>
          </div>
        ))}
      </div>
    </div>
  </section>
 


</main>



           
            <Footer />
        </>

    );
};

export default TestingHospitalView